// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as Rect$Linear from "lumi-linear/lib/es6/src/Rect.res.js";
import * as Rectf$Linear from "lumi-linear/lib/es6/src/Rectf.res.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Cone$LumiFacilityMap from "./Cone.res.js";
import * as Scale$LumiFacilityMap from "./Scale.res.js";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as MapLabel$LumiFacilityMap from "./MapLabel.res.js";
import * as NonRotated$LumiFacilityMap from "./NonRotated.res.js";
import * as ObjectStyle$LumiFacilityMap from "./ObjectStyle.res.js";
import * as DisplayStyle$LumiFacilityMap from "./DisplayStyle.res.js";

function DisplayObject(props) {
  let __displayStyle = props.displayStyle;
  let objectTransform = props.objectTransform;
  let mapTransform = props.mapTransform;
  let displayStyle = __displayStyle !== undefined ? __displayStyle : DisplayStyle$LumiFacilityMap.empty;
  let scale = Scale$LumiFacilityMap.fixedInScreenSpace(props.scale, mapTransform, undefined, undefined);
  let className = ObjectStyle$LumiFacilityMap.className(displayStyle.objectStyle);
  let rectSize_0 = scale * 1.6;
  let rectSize_1 = scale * 1.2;
  let rectSize = [
    rectSize_0,
    rectSize_1
  ];
  let rectPos = V2f$Linear.scale(rectSize, -0.5);
  let edgeLength = scale * 1.2;
  let angle = Math.PI * 0.75;
  let outerTransform = Transform$Linear.M23f.compose(mapTransform, objectTransform);
  let match = V2f$Linear.mapToString(rectPos);
  let match$1 = V2f$Linear.mapToString(rectSize);
  return JsxRuntime.jsxs("g", {
    children: [
      JsxRuntime.jsx(Cone$LumiFacilityMap.make, {
        edgeLength: edgeLength,
        angle: angle,
        className: "orientation",
        closed: false
      }),
      LumiReact.renderOption(undefined, displayStyle.objectStyle.label, label => {
        let offset_1 = V2$Linear.y(rectSize) * -0.55;
        let offset = [
          0,
          offset_1
        ];
        return JsxRuntime.jsx(MapLabel$LumiFacilityMap.make, {
          outerTransform: outerTransform,
          offset: offset,
          className: "label is-unselectable",
          dominantBaseline: "text-bottom",
          scale: scale,
          children: label
        });
      }),
      JsxRuntime.jsxs(NonRotated$LumiFacilityMap.make, {
        outerTransform: outerTransform,
        children: [
          JsxRuntime.jsx("rect", {
            className: "rect",
            style: displayStyle.objectStyle.style,
            height: match$1[1],
            width: match$1[0],
            vectorEffect: "non-scaling-stroke",
            x: match[0],
            y: match[1]
          }),
          LumiReact.renderOption(undefined, displayStyle.contents, param => {
            let boundingBox = param.boundingBox;
            let match = Rect$Linear.map(boundingBox, prim => prim);
            let match$1 = match.size;
            let scale = Math.min(rectSize_0 / match$1[0], rectSize_1 / match$1[1]) * 0.9;
            let aabbCenter = V2f$Linear.scale(Rectf$Linear.center(Rect$Linear.map(boundingBox, prim => prim)), - scale);
            let transform = LumiSVG.Transform.list([
              LumiSVG.Transform.Float.translate(aabbCenter),
              LumiSVG.Transform.Float.scale(V2$Linear.fill(scale))
            ]);
            let match$2 = Rect$Linear.map(boundingBox, x => x.toString());
            let match$3 = match$2.size;
            let match$4 = match$2.pos;
            return JsxRuntime.jsxs("g", {
              children: [
                JsxRuntime.jsx("rect", {
                  height: match$3[1],
                  width: match$3[0],
                  fill: "black",
                  stroke: "none",
                  x: match$4[0],
                  y: match$4[1]
                }),
                param.element
              ],
              transform: transform
            });
          })
        ]
      }),
      LumiReact.renderOption(undefined, displayStyle.objectStyle.title, title => JsxRuntime.jsx("title", {
        children: title
      }))
    ],
    className: className,
    onClick: props.onClick,
    transform: LumiSVG.Transform.Matrix.fromM23f_(objectTransform)
  });
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

let make = DisplayObject;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  make,
}
/* LumiSVG Not a pure module */
